"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultValue = void 0;
function generateExperimentSDRN(id, experimentationPlatform) {
    return "sdrn:".concat(experimentationPlatform, ":experiment:").concat(id);
}
/**
 * Attempts to format a correct "@id" given the input.
 * Allows for the "@id" property to be completely overridden by the dev's input
 * @param experiment
 */
function formatExperiment(experiment) {
    var _a = experiment || {}, id = _a.id, platform = _a.platform, rest = __rest(_a, ["id", "platform"]);
    return __assign(__assign({ '@id': generateExperimentSDRN(id, platform) }, (platform && { platform: platform })), rest);
}
/**
 * Experiments builder
 * @param input A full Pulse Event, from where the "experiments" property is parsed.
 */
function experiments(input) {
    var experimentList = (input || {}).experiments || [];
    if (experimentList.length > 0) {
        return experimentList.map(formatExperiment);
    }
}
exports.default = experiments;
var defaultValue = function () { return undefined; };
exports.defaultValue = defaultValue;
